import moment from "moment";

import { data } from "../../constants";
import { FirebaseApplicant } from "../../core/entities/applicant";

export const statusFilter = (isJobOffer?: boolean) => {
  const statuses = [
    ...(isJobOffer ? data.jobOfferStatuses : data.applicationStatus),
    "Unassigned",
  ];
  return statuses.map((status: string) => {
    return { text: status, value: status };
  });
};

export const filterFailed = (data: FirebaseApplicant[], item: string) => {
  const failedPhases: any = {
    failedNewApplicant: "New Applicant",
    failedShortlisted: "Shortlisted",
    failedTechnical: "Technical Exam",
    failedInitial: "Initial Interview",
    failedPsychological: "Psychological Exam",
    failedFinal: "Final Interview",
  };

  return data
    .filter(
      (applicant: FirebaseApplicant) =>
        applicant.applicationStatus.currentStatus === "Failed" &&
        applicant.applicationStatus.failedPhase === failedPhases[item]
    )
    .map((applicant: FirebaseApplicant) => {
      const status =
        !applicant.applicationStatus?.subStatus ||
        applicant.applicationStatus?.subStatus === "Read" ||
        applicant.applicationStatus?.subStatus === "Unread"
          ? ""
          : applicant.applicationStatus?.subStatus;
      const applicantName = applicant.applicantName
        ? `${applicant.applicantName.firstName} ${applicant.applicantName.middleName} ${applicant.applicantName.lastName}`
        : applicant.fullName;
      return {
        key: applicant.id,
        name: applicantName,
        position: applicant.positionApplied,
        dateMoved: applicant.applicationStatus.dateMoved
          ? `${moment(applicant.applicationStatus.dateMoved.toDate()).format(
              "MM/DD/YYYY hh:mm a"
            )}`
          : null,
        dateApplied: `${moment(applicant.createdAt.toDate()).format(
          "MM/DD/YYYY hh:mm a"
        )}`,
        status: status || "Unassigned",
        // TODO: Reason select dropdownn not yet implemented on move to fail modal
        reason: applicant.applicationStatus.reason || "",
        referredBy: applicant.referredBy,
      };
    });
};
